export default function Header() {
    return (
        <header>
            <h1>MCB Character Creator</h1>
        </header>
    );
}